// What's on Your Plate: the charities PlateX supports and the fundraising record.
//
// The charities and their logos are the owner's choice (3 November 2026).
// Facts are taken from each charity's own website. Ledger rows are added only
// for money actually collected or transferred: the page shows the reporting
// figures only when real rows exist, so nothing here is ever a placeholder.

export interface Beneficiary {
  name: string;
  /** Registered charity number(s), as the charity states them. */
  charityNumber: string;
  /** Concise explanation of the charity's work. */
  summary: string;
  /** Official website. */
  url: string;
  /** Logo under src/assets/woyp, shown to identify the charity. */
  logo: string;
}

/** Money received from sales of a publication (collected, not yet donated). */
export interface Collection {
  publication: string;
  periodLabel: string; // e.g. "November 2026"
  amountMinor: number;
}

/** Money actually transferred to a beneficiary. */
export interface Transfer {
  beneficiary: string;
  date: string; // ISO date of the transfer
  amountMinor: number;
  publication?: string;
}

export const BENEFICIARIES: Beneficiary[] = [
  {
    name: 'Samaritans',
    charityNumber: '219432 (England and Wales), SC040604 (Scotland)',
    summary:
      'Samaritans is there round the clock for anyone who is struggling to cope. Call free on 116 123, any time, from any phone.',
    url: 'https://www.samaritans.org',
    logo: 'assets/woyp/samaritans.svg',
  },
  {
    name: 'Mind',
    charityNumber: '219830 (England)',
    summary:
      'Mind gives information, advice and support to anyone with a mental health problem, through its helplines and local Minds, and campaigns for better services and understanding.',
    url: 'https://www.mind.org.uk',
    logo: 'assets/woyp/mind.png',
  },
  {
    name: 'ANDYSMANCLUB',
    charityNumber: '1179647 (England and Wales)',
    summary:
      'A men’s suicide prevention charity running free peer-to-peer support groups across the UK and online, every Monday at 7pm except bank holidays.',
    url: 'https://andysmanclub.co.uk',
    logo: 'assets/woyp/andysmanclub.png',
  },
];

/**
 * Answers on the hero's yellow plate, as registrations read (the owner's
 * picks, 3 November 2026). All are valid dateless formats: keep any new one
 * to a real format (see the plate validator), spaced as it would be on a car.
 */
export const ANSWERS: string[] = ['DEB 7', '621 EF', 'LO 55', 'STR 355', 'FEA 2'];

export const COLLECTIONS: Collection[] = [];
export const TRANSFERS: Transfer[] = [];
